export var ContentCardLayout;
(function (ContentCardLayout) {
    ContentCardLayout["default"] = "default";
    ContentCardLayout["condensed"] = "condensed";
    ContentCardLayout["infoPane"] = "infoPane";
    ContentCardLayout["infoPaneSplitVertical"] = "infoPaneSplitVertical";
    ContentCardLayout["infoPaneSplitHorizontal"] = "infoPaneSplitHorizontal";
})(ContentCardLayout || (ContentCardLayout = {}));
